module.exports = __webpack_public_path__ + "img/lt-icone-mail-violet.d57e6e7a.png";